/**
 * A short slow motion on the kill (x-aaa-gap#5): the fall plays at a third of its pace for half a
 * second, then eases back to full pace. Only what is drawn slows – clips, the body's fall, sparks,
 * the camera. The simulation is already over by then and the sound keeps its time.
 */
export const KILL_SLOW_SECONDS = 0.5;
export const KILL_EASE_SECONDS = 0.4;
export const KILL_PACE = 0.3;

/** How fast the duel is drawn this long (real seconds) after the blow that ended it. */
export function killPace(sinceKill: number): number {
  if (!(sinceKill >= 0) || sinceKill >= KILL_SLOW_SECONDS + KILL_EASE_SECONDS) return 1;
  if (sinceKill < KILL_SLOW_SECONDS) return KILL_PACE;
  const t = (sinceKill - KILL_SLOW_SECONDS) / KILL_EASE_SECONDS;
  return KILL_PACE + (1 - KILL_PACE) * t * t * (3 - 2 * t);
}
